<template>
    <div v-if="isPc" class="honor-container">
        <div v-for="(item, index) in honorList" :key="index" class="frame-container">
            <img class="award-image" :src="item.awardImage + '.webp'" alt="Award Image" loading="lazy" />
        </div>
    </div>
    <div v-else class="mob-honor-container">
        <div v-for="(item, index) in honorList" :key="index" class="mob-frame-container">
            <img class="mob-award-image" :src="item.mobAwardImage + '.webp'" alt="Award Image" loading="lazy" />
        </div>
    </div>
</template>

<script>
import { dataReport } from '../../../../../../utils/report';
export default {
    props: {
        isPc: {
            type: Boolean,
            default: true
        },
        honorInfo: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            // honorList: [
            //     {
            //         awardImage: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181631-b1bb489a-ca17-472a-84fa-0a9a33763ddd.png",
            //         awardText: "连续七年获得《亚洲银行家》大奖",
            //         leftDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181632-37ea626b-5d11-457c-b1d8-922d2a06d352.png",
            //         rightDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181631-17931b76-6465-47b8-b375-4ded4fee8e6d.png",
            //     },
            //     {
            //         awardImage: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909195237-52cb83fd-6531-4b48-9693-0b72d1877b99.png",
            //         awardText: "入选中国互联网 企业100强",
            //         leftDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181632-37ea626b-5d11-457c-b1d8-922d2a06d352.png",
            //         rightDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181631-17931b76-6465-47b8-b375-4ded4fee8e6d.png",
            //     },
            //     {
            //         awardImage: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909195311-fd62b8ae-c18c-437f-84a4-88a057a4674d.png",
            //         awardText: "入选哈佛大学 Fintech精品课程案例",
            //         leftDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181632-37ea626b-5d11-457c-b1d8-922d2a06d352.png",
            //         rightDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181631-17931b76-6465-47b8-b375-4ded4fee8e6d.png",
            //     },
            //     {
            //         awardImage: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909195411-a1455db2-0b91-4bc6-8ea2-294da1f28d52.png",
            //         awardText: "入围深圳新40年 十大创新之星榜单",
            //         leftDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181632-37ea626b-5d11-457c-b1d8-922d2a06d352.png",
            //         rightDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181631-17931b76-6465-47b8-b375-4ded4fee8e6d.png",
            //     },
            //     {
            //         awardImage: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909195512-836dcd22-2ace-4d1c-839e-5caefaffabd6.png",
            //         awardText: "连续五年入围 中国服务业企业500强",
            //         leftDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181632-37ea626b-5d11-457c-b1d8-922d2a06d352.png",
            //         rightDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181631-17931b76-6465-47b8-b375-4ded4fee8e6d.png",
            //     },
            //     {
            //         awardImage: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909195558-494a2a7e-66e3-4294-959d-115c1391de7f.png",
            //         awardText: "上榜广东省 民营企业100强",
            //         leftDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181632-37ea626b-5d11-457c-b1d8-922d2a06d352.png",
            //         rightDecoration: "https://coss-platform.fenqile.com/platformresource200/M00/ex/20250909181631-17931b76-6465-47b8-b375-4ded4fee8e6d.png",
            //     }

            // ]
        };
    },
    computed: {
        honorList() {
            return this.honorInfo[1]?.map(item => ({
                awardImage: item.img,
                mobAwardImage: item.img_mob,
            }))
        }
    },
    methods: { 
        handleExposure() {
            if (this.isPc) {
                dataReport(
                {
                    hottag: `FQL_HOME_WEB_HONOR_EXPOSURE`,
                    eventPosName: `分期乐web首页荣誉展示`,
                    eventType: 1, //展示
                }
            );
            }
            else {
                dataReport(
                {
                    hottag: `FQL_HOME_MOB_HONOR_EXPOSURE`,
                    eventPosName: `分期乐MOB首页荣誉展示`,
                    eventType: 1, //展示
                }
            );
            }
        }
    },
    watch: {
        honorList: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.handleExposure();
                }
            },
            immediate: true
        }
    },
};
</script>
<style scoped>
.honor-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}

.mob-honor-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 91%;
    border-radius: 4px;
    background: linear-gradient(180deg, #FFE4CC -23.31%, #FFF 14.83%);
    padding-left: 21px;
    padding-right: 21px;
    padding-top: 30px;
    padding-bottom: 6px;
    justify-content: space-around;
}

.frame-container {
    width: 380px;
    height: 212px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    border-radius: 4px;
    border: 1px solid #FFF;
    background: #FFF;
    box-shadow: 4px 2px 10px 0 rgba(214, 220, 236, 0.35);
    margin-bottom:28px;
}



.content-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
}

.award-text {
    color: rgb(108, 78, 54);
    font-size: 20px;
}

.decoration-image {
    width: 22px;
    height: auto;
}

.award-image {
    width: 380px;
    height: auto;
}

.mob-award-image {
    width: 136px;
    height: 130px;
    margin-bottom: 28px;
}
</style>